'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFontFormat;
/*  weak */
var formats = {
  '.woff': 'woff',
  '.eot': 'eot',
  '.ttf': 'truetype',
  '.svg': 'svg'
};

// Returns the font format for a specific font source
function getFontFormat(src) {
  return Object.keys(formats).reduce(function (format, extension) {
    if (src.indexOf(extension) > -1) {
      format = formats[extension];
    }
    return format; // eslint-disable-line
  }, undefined);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/fela/lib/utils/getFontFormat.js
// module id = 438
// module chunks = 0